import React, { MouseEvent } from 'react';
import classNames from 'classnames';
import { FCP } from 'types';

import ZpButton from 'components/zpButton';
import { gtm } from 'utils/gtm';
import { urlFragment } from 'utils/v2';

import classes from './index.module.css';

interface Item {
  title: string;
  link: string;
}

interface TopJobsNearYouProps extends FCP {
  jobTitle: string;
  src?: string;
  items: Item[];
}

const TopJobsNearYou = ({
  jobTitle = '',
  className,
  items = [],
  src = '',
}: TopJobsNearYouProps) => {
  const onLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const url = event.currentTarget.href;
    const slug = urlFragment(url);

    gtm.logJobCalloutClick(slug);
  }

  return (
    <div className={classNames(classes.card, className)}>
      <div className="z-font-20 z-font-600 z-mt-2 text-capitalize">
        {`Top ${jobTitle.toLowerCase()} jobs near you`}
      </div>
      <div className="z-mb-4">
        {items.map(({ link, title }, index) => (
          <div className={classes['card-item']} key={`${title}_${index}`}>
            <a href={link + src} onClick={onLinkClick}>
              <ZpButton size="big" theme="link">
                {title}
              </ZpButton>
            </a>
          </div>
        ))}
      </div>
      <a href={'/jobs/' + src} onClick={onLinkClick}>
        <ZpButton isFullWidth theme="primary" size="big" className="text-capitalize">
          View more jobs on Zippia
        </ZpButton>
      </a>
    </div>
  )
};

export default TopJobsNearYou;
